export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_ERROR = 'FETCH_EVENTS_ERROR';
export const SET_EVENTS_CURRENCY = 'SET_EVENTS_CURRENCY';

export const DELETE_EVENT_REQUEST = 'DELETE_EVENT_REQUEST';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR';

export const DELETE_TRANSACTION_REQUEST = 'DELETE_TRANSACTION_REQUEST';
export const DELETE_TRANSACTION_SUCCESS = 'DELETE_TRANSACTION_SUCCESS';
export const DELETE_TRANSACTION_ERROR = 'DELETE_TRANSACTION_ERROR';

export const MOVE_TRANSACTION_REQUEST = 'MOVE_TRANSACTION_REQUEST';
export const MOVE_TRANSACTION_SUCCESS = 'MOVE_TRANSACTION_SUCCESS';
export const MOVE_TRANSACTION_ERROR = 'MOVE_TRANSACTION_ERROR';

export const ADD_EVENT_REQUEST = 'ADD_EVENT_REQUEST';
export const ADD_EVENT_SUCCESS = 'ADD_EVENT_SUCCESS';
export const ADD_EVENT_ERROR = 'ADD_EVENT_ERROR';

export const FETCH_EVENT_REQUEST = 'FETCH_EVENT_REQUEST';
export const FETCH_EVENT_SUCCESS = 'FETCH_EVENT_SUCCESS';
export const FETCH_EVENT_ERROR = 'FETCH_EVENT_ERROR';

export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
export const CLEAR_CURRENT_EVENT = 'CLEAR_CURRENT_EVENT';
export const SET_CURRENT_EVENT_ID = 'SET_CURRENT_EVENT_ID';
export const SET_EVENT_CURRENCY = 'SET_EVENT_CURRENCY';
export const SET_EVENT_ORIGINAL = 'SET_EVENT_ORIGINAL';

export const FETCH_OPERATIONS_REQUEST = 'FETCH_OPERATIONS_REQUEST';
export const FETCH_OPERATIONS_SUCCESS = 'FETCH_OPERATIONS_SUCCESS';
export const FETCH_OPERATIONS_ERROR = 'FETCH_OPERATIONS_ERROR';
export const CLEAR_OPERATIONS_UPDATE_STATUS = 'CLEAR_OPERATIONS_UPDATE_STATUS';

export const FETCH_EVENT_EXPENSES_REQUEST = 'FETCH_EVENT_EXPENSES_REQUEST';
export const FETCH_EVENT_EXPENSES_SUCCESS = 'FETCH_EVENT_EXPENSES_SUCCESS';
export const FETCH_EVENT_EXPENSES_ERROR = 'FETCH_EVENT_EXPENSES_ERROR';
export const CLEAR_EVENT_EXPENSES_UPDATE_STATUS = 'CLEAR_EVENT_EXPENSES_UPDATE_STATUS';

export const USER_PAYOUTS_REQUEST = 'USER_PAYOUTS_REQUEST';
export const USER_PAYOUTS_SUCCESS = 'USER_PAYOUTS_SUCCESS';
export const USER_PAYOUTS_ERROR = 'USER_PAYOUTS_ERROR';
export const UPDATE_USER_PAYOUTS = 'UPDATE_USER_PAYOUTS';
export const ADD_PAYOUT_USER = 'ADD_PAYOUT_USER';
export const DELETE_PAYOUT_USER = 'DELETE_PAYOUT_USER';
export const SET_USER_PAYOUTS_CURRENCY = 'SET_USER_PAYOUTS_CURRENCY';

export const USER_PAYOUT_REQUEST = 'USER_PAYOUT_REQUEST';
export const USER_PAYOUT_SUCCESS = 'USER_PAYOUT_SUCCESS';
export const USER_PAYOUT_ERROR = 'USER_PAYOUT_ERROR';
export const SET_PAYOUTS_ACTIVE_USER = 'SET_PAYOUTS_ACTIVE_USER';

export const SEND_ALL_PAYOUTS_REQUEST = 'SEND_ALL_PAYOUTS_REQUEST';
export const SEND_ALL_PAYOUTS_SUCCESS = 'SEND_ALL_PAYOUTS_SUCCESS';
export const SEND_ALL_PAYOUTS_ERROR = 'SEND_ALL_PAYOUTS_ERROR';

export const EVENT_PAYOUTS_REQUEST = 'EVENT_PAYOUTS_REQUEST';
export const EVENT_PAYOUTS_SUCCESS = 'EVENT_PAYOUTS_SUCCESS';
export const EVENT_PAYOUTS_ERROR = 'EVENT_PAYOUTS_ERROR';

export const ADD_TRANSACTION_REQUEST = 'ADD_TRANSACTION_REQUEST';
export const ADD_TRANSACTION_SUCCESS = 'ADD_TRANSACTION_SUCCESS';
export const ADD_TRANSACTION_ERROR = 'ADD_TRANSACTION_ERROR';

export const UPDATE_EVENT_REQUEST = 'DELETE_EVENT_USER_REQUEST';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_ERROR = 'UPDATE_EVENT_ERROR';
export const SET_USER_TO_DELETE = 'SET_USER_TO_DELETE';
export const CLEAR_USER_TO_DELETE = 'CLEAR_USER_TO_DELETE';

export const CLEAR_EVENT_DATA = 'CLEAR_EVENT_DATA';
export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const RESET_EVENT_DATA = 'RESET_EVENT_DATA';
